//Third Party Dependencies
import React, { useState, useEffect } from 'react';
import { Row } from 'reactstrap';

//MHD General Purpose libraries
import { SectionHeading } from '../../components/common/standardComponents';
import LoadingIndicator from '../../components/loadingIndicator';
import ActiveErrors from '../../components/common/activeErrors';

//Specific Business and UI components
import * as routes from '../../routes';
import * as appointmentActions from '../../actions/appointmentActions';
import AppointmentEditForm from '../../components/appointment/appointmentEditForm';
import BookingDetails from '../../components/appointment/bookingDetails';

//MHD General Purpose libraries
import { useAppHistory } from 'hooks';
import { useAppDispatch, useAppSelector } from "../../store";
import { withRouter } from 'components/hoc';

function AppointmentEditView(props: any) {

	const [error, setError] = useState<string>('');
	const [isDetailsLoaded, setIsDetailsLoaded] = useState<boolean>(false);
	const [isSaving, setIsSaving] = useState<boolean>(false);
	const [referenceId, setReferenceId] = useState<string>('');
	const [reasonForVisit, setReasonForVisit] = useState<string>('');
	const [providerResponse, setProviderResponse] = useState<string>('');

	const activePatient: any = useAppSelector((state: any) => state.activePatient);
	const appointmentManagementConfig: any = useAppSelector((state: any) => state.config.appointmentManagement);
	const details: any = useAppSelector((state: any) => state.appointment.details);
	const providerFieldConfig: any = useAppSelector((state: any) => state.config.provider);
	const schedulingConfig: any = useAppSelector((state: any) => state.config.scheduling);
	const routePrefix: any = useAppSelector((state: any) => state.config.instance.routePrefix);

	const dispatch = useAppDispatch();

	const history = useAppHistory();

	const appointmentDetails = (referenceId: string) => {
		setIsDetailsLoaded(false);
		dispatch(appointmentActions.getAppointmentByReferenceId(referenceId))
			.then((response: any) => {
				if (response.error) {
					setError('An error occurred while trying to get the appointment details.');
				}
				setIsDetailsLoaded(true);
			})
			.catch((err: any) => {
				setError('Error');
			});
	}

	useEffect(() => {
		const params = props.params;
		const isDetailsAlreadyActive = (details.referenceId === params.referenceId);
		if (isDetailsAlreadyActive) {
			const isDetailsAlreadyLoaded = isDetailsAlreadyActive && (details.referenceId !== undefined);
			if (isDetailsAlreadyLoaded) {
				setIsDetailsLoaded(isDetailsAlreadyLoaded);
				setReferenceId(details.referenceId ? details.referenceId : '');
				setReasonForVisit(details.reasonForVisit ? details.reasonForVisit : '');
				setProviderResponse(details.providerResponse ? details.providerResponse : '');
			}
		} else {
			appointmentDetails(params.referenceId);
		}
	}, [])

	const handleCancel = (e: any) => {
		e.preventDefault();
		if (history.navigate.length > 0) {
			history.goBack();
		}
		else {
			dispatch(routes.appointmentDetails(routePrefix, props.appointmentReferenceId));
		};
	}

	const handleChange = (e: any) => {
		e.preventDefault();
		const { name, value } = e.target;

		switch (name) {
			case "reasonForVisit":
				setReasonForVisit(value);
				return;
			case "providerResponse":
				setProviderResponse(value);
				return;
			default:
				return;
		}
	}

	const handleSave = (e: any) => {
		e.preventDefault();
		setIsSaving(true);

		let editRequest = {
			referenceId: details.referenceId,
			reasonForVisit: reasonForVisit,
			providerResponse: providerResponse,
			doUpdateReasonForVisit: reasonForVisit !== details.reasonForVisit ? true : false,
			doUpdateProviderResponse: providerResponse !== details.providerResponse ? true : false,
		};

		dispatch(appointmentActions.updateAppointment(editRequest))
			.then((response: any) => {
				if (response.error) {
					setError('An error occurred while trying to save appointment notes.');
					setIsSaving(false);
				} else {
					dispatch(routes.appointmentDetails(routePrefix, details.referenceId));
				}
			})
			.catch((err: any) => {
				setError('An error occurred while trying to save appointment notes.');
				setIsSaving(false);
			});
	}


	return (
		<div>
			{isSaving ?
				<LoadingIndicator loadingMessage={!isDetailsLoaded ? "Loading appointment. Please wait." : isSaving ? "Saving changes. Please wait." : "Please Wait"} />
				:
				<>
					<ActiveErrors />
					<SectionHeading label="Edit Appointment" />
					<div className="form-area">
						<BookingDetails
							config={schedulingConfig}
							providerFieldConfig={providerFieldConfig}
							reservationDetails={details}
						/>
					</div>
					<Row className="g-0">
						<div className="col-lg-12">
							<AppointmentEditForm
								config={schedulingConfig}
								details={details}
								reasonForVisit={reasonForVisit}
								providerResponse={providerResponse}
								isSaving={isSaving}
								onChange={handleChange}
								onCancel={handleCancel}
								onSave={handleSave}
								enableEditProviderResponse={appointmentManagementConfig.enableEditProviderResponse}
								enableEditReasonForVisit={appointmentManagementConfig.enableEditReasonForVisit}

							/>
						</div>
					</Row>
				</>
			}
		</div>
	)
}

export default withRouter(AppointmentEditView);
